import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import './BrokerApplicationForm.scss';
import { actions } from '../redux/brokerApplicationActions';
import BrokerApplicationForm from '../components/BrokerApplicationForm/BrokerApplicationForm';

import { getAvailableProducts } from '../../broker/helpers';
import { Loader } from '../../../common/components';

/***********************************
 Container for the New Broker Application Form
 ************************************/

const resource = {
  data: {
    type: 'broker-application',
    attributes: {
      branch_name: '',
      organisation: {
        data: {},
      },
      metadata: {
        renewals_enabled: false,
        generate_documents: false,
        account: {
          gwp_all: '',
          gwp_travel: '',
          annual_income: '',
          main_companies: [],
          hold_standards: '',
          special_arrangements: '',
          has_insurer_restrictions: '',
          has_sub_broking: '',
        },
        insurer: {
          name: '',
          policy_number: '',
          expiry_date: '',
          excess: '',
          indemnity_cover: '',
          aggregate_limit: '',
          include_partner_dishonesty: null,
          include_staff_dishonesty: null,
          claim_rise: null,
        },
        directors: [],
        declaration: {
          questions: {
            truthful: null,
            competent: null,
            experience: null,
          },
          broker_declaration: null,
          position: '',
          date: '',
        },
      },
    },
    relationships: {
      legal_entity_type: {
        data: null,
      },
    },
  },
};

const BrokerApplicationNewContainer = ({
  createBrokerApplication,
  updateBrokerApplication,
  clearExistingOrganisation,
  resendBrokerApplication,
  declineBrokerApplication,
  saveAndApproveBrokerApplication,
  getProductInsurers,
  user,
  brokerApplication,
}) => {
  const create = (resource, redirect) => {
    return createBrokerApplication(resource, redirect);
  };
  const update = (resource) => {
    return updateBrokerApplication(resource);
  };

  useEffect(
    () => {
      getProductInsurers();
    },
    [getProductInsurers],
  );

  const availableProducts = useMemo(() => getAvailableProducts(user), [user]);

  if (!brokerApplication?.productInsurers?.length) {
    return <Loader />;
  }

  return (
    <BrokerApplicationForm
      availableProducts={availableProducts}
      onClearExistingOrganisation={clearExistingOrganisation}
      onSaveAndApproveBrokerApplication={saveAndApproveBrokerApplication}
      onResendBrokerApplication={resendBrokerApplication}
      onDeclineBrokerApplication={declineBrokerApplication}
      resource={resource}
      insurers={brokerApplication?.productInsurers}
      onSave={create}
      onUpdate={update}
      isSubmitting={brokerApplication.isSubmitting}
    />
  );
};

export default connect(
  (state) => {
    return {
      brokerApplication: state.brokerApplication,
      user: state.auth.user,
    };
  },
  {
    createBrokerApplication: actions.createBrokerApplication,
    updateBrokerApplication: actions.updateBrokerApplication,
    declineBrokerApplication: actions.declineBrokerApplication,
    saveAndApproveBrokerApplication: actions.saveAndApproveBrokerApplication,
    resendBrokerApplication: actions.resendBrokerApplication,
    clearExistingOrganisation: actions.clearExistingOrganisation,
    getProductInsurers: actions.getProductInsurers,
  },
)(BrokerApplicationNewContainer);
